import React from 'react';

import styled from 'styled-components';
import { JRCIcon } from 'components/JRCIcon/JRCIcon';

export const CSSMailItemCount = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

export const WidgetEmailsImapAttachments = ({ count }: { count: number }) => {
    if (!count) return <></>;
    return (
        <CSSMailItemCount>
            {count}
            <JRCIcon name={'icon-paperclip'} />
        </CSSMailItemCount>
    );
};
